import { OrganizationsTable } from "components/OrganizationsTable/OrganizationsTable";
import { FC, useEffect } from "react";
import { useAppDispatch } from "toolkit/hooks";
import { changeMode } from "toolkit/organizations/organizations.slice";

export const Organizations: FC = () => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(changeMode("categorization"));
		//eslint-disable-next-line
	}, []);

	return <OrganizationsTable title={"Выбор организации для категорирования"} />;
};
